(function () {
    var ev = document.getElementsByClassName("js-encrypt-email");
    $('.js-encrypt-email').click(function (event) {
        var mail = $('.encrypt-email').val();
        var md5Hash = CryptoJS.MD5(mail);
        var sha256Hash = CryptoJS.SHA256(md5Hash);
        const urlApi = 'https://stags.bluekai.com/site/90426?limit=0&id=' + sha256Hash;
        fetch(urlApi, {
            mode: 'no-cors' // 'cors' by default
        })
    });
})();